export const GRAPH_MINI_FILL_COLOR = [
  "#13388C",
  "#15946C",
  "#15607A",
  "#1D81A2",
  "#BCBCBC",
];

export const GRAPH_FILL_COLOR = [
  "#13388C", // Deep Blue
  "#f15a29", // Orange Red
  "#1278b7", // Deep Sky Blue
  "#b36512", // Pure Green
  "#dc5353", // Bright Blue-Teal
  "#a71351", // Crimson
  "#28bf61", // Light Coral
  "#355fd3", // Rich Aqua
  "#6a871f", // Neutral Olive Green
  "#4b24cd", // Blue Violet
  "#574f8c", // Tomato Red
  "#bc6c1b", // Dark Violet
  "#b33d00", // Cadet Blue
  "#15946C", // Vivid Teal
  "#f44141", // Dark Orange
  "#890a07", // Orange
  "#209c51", // Light Pink
  "#8d4884", // Lime Green
  "#191970", // Indigo
  "#ba1e5f", // Dark Red
  "#4545e2", // Lawn Green
  "#1b9381", // Light Sea Green
  "#964b00", // Deep Pink
  "#a932c7", // Chartreuse
];
